export const revenueRecognitionPolicyTag = 'RevenueRecognitionPolicy:';
